import { defaultHttpClient } from './_HttpClient';
export async function LoadInventory(productId) {
    const data = {
        productId: productId,
    };
    const response = await defaultHttpClient.post('/Ajax/ProductDetail.aspx/GetStockList', data);
    const rs = response.data;
    return JSON.parse(rs.d).Data;
}
